import { Box } from '@mui/material';

import { sendUserPortalEvent } from '@/lib/analytics/unified.ts';

import GingerbreadMan from '../_assets/gingerbread-man.svg?styled';
import { CTA } from '../_components/CTA.tsx';
import { Section } from '../_components/Section.tsx';

export type MidSectionProps = {};

export const MidSection: React.FC<MidSectionProps> = () => {
  return (
    <Section>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: 6,
        }}
      >
        <Box
          sx={{
            flex: { xs: 1, lg: 2 },
            p: { xs: 0, sm: 4, md: 6 },
            my: 'auto',
          }}
        >
          <div className="mb-6 typography-v1-body3">
            Vi har fylt opp vår julekalender med <b>2&nbsp;800&nbsp;000&nbsp;kr</b>!
            <br />
            Hver eneste dag fra 1-23 des. trekker vi en vinner som får <b>
              100&nbsp;000&nbsp;kr
            </b>{' '}
            til nedbetaling av kredittkortgjeld.
            <br />
            <br />
            24 des. trekker vi en vinner som får slettet <b>500&nbsp;000&nbsp;kr</b> av sin
            forbruks- og kredittkortgjeld.
          </div>

          <CTA
            onClick={() => {
              sendUserPortalEvent('adv25_competition_cta_mid_clicked');
            }}
          />
        </Box>

        <Box
          sx={{
            flex: { xs: 1, lg: 3 },
            backgroundColor: '#F0F4FA',
            p: { xs: 2, sm: 4, md: 8 },
            pb: { xs: 12, sm: 12, md: 12, lg: 10 },
            pr: { lg: 15 },
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <Box component="div" sx={{ mb: { xs: 2, md: 4 } }} className="typography-v1-h2">
            Lavere rente på gjelden du har
          </Box>

          <p className="mb-4 typography-v1-body4">
            Vi vil at enda flere skal sjekke om de kan få lavere rente! Med lavere rente blir det
            nemlig lettere å betale på forbruks- og kredittkortgjelden.
          </p>

          <div className="mb-4 typography-v1-body4">
            <ul style={{ listStylePosition: 'inside', paddingLeft: 0 }}>
              <li>Betal mindre i måneden</li>
              <li>Få en lavere totalkostnad</li>
              <li>Spar penger</li>
            </ul>
          </div>

          <p className="typography-v1-body4">
            Ved å søke om lavere rente sjekker vi med alle våre samarbeidsbanker for å se hvem som
            kan gi deg det beste tilbudet. Får du tilbud om lavere rente samler vi gjelden din og
            flytter den til banken med det beste tilbudet. På den måten har du den samme gjelden,
            bare med lavere rente!
          </p>

          <GingerbreadMan
            sx={{
              position: 'absolute',
              bottom: { xs: '-28px', lg: '50%' },
              right: { xs: '50%', lg: '-28px' },
              transform: {
                xs: 'translateX(50%)',
                lg: 'translateY(50%) scale(1.5)',
              },
            }}
          />
        </Box>
      </Box>
    </Section>
  );
};
